import isDomainSearchQueryValid from './is-domain-search-query-valid';

const EMPTY_OPTIONS = [];

function getAutocompleteOptions(tldCollection, domainToSearch) {
  if (!isDomainSearchQueryValid(domainToSearch) || domainToSearch.length < 3) return EMPTY_OPTIONS;

  return tldCollection.reduce((result, tld) => {
    result.push({
      label: `${domainToSearch}.${tld}`,
      value: `${domainToSearch}.${tld}`,
      tld,
    });

    return result;
  }, []);
}

export default getAutocompleteOptions;
